var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-link',{staticClass:"btn btn-primary",attrs:{"href":("mailto:" + _vm.adminEmail)}},[_vm._t("default",function(){return [_vm._v("Contact Admin")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }